import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";
import { useEffect, useState } from "react";

const Banner = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000);
  }, [])
  return (
    <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "45px", width: "auto" }}>
    <div className="panel-banner">
      <span>HSA & FSA Eligible. Out-of-network reimbursement up to 70%</span>
    </div>
    </ReactPlaceholder>
  );
};
export default Banner;
 